import { DEFAULT_PARAMS, type Params } from '../shared/params';
import type { StringKey } from './i18n';

export interface Preset {
  id: string;
  labelKey: StringKey;
  params: Params;
}

const base = DEFAULT_PARAMS;

export const PRESETS: Preset[] = [
  {
    id: 'default',
    labelKey: 'preset.default',
    params: { ...base },
  },
  {
    // GBA-ish: small sprite grid, heavy outlines, tight palette, ordered dither
    id: 'gba',
    labelKey: 'preset.gba',
    params: {
      ...base,
      targetW: 240,
      targetH: 160,
      pixelSize: 4,
      thickness: 4,
      mode: 'contrast',
      doColorMatch: true,
      doQuant: true,
      numColors: 32,
      quantMode: 'kmeans',
      ditherMode: 'ordered',
    },
  },
  {
    // Keep as much detail as possible: small pixels, strong expansion, no palette
    id: 'detail',
    labelKey: 'preset.detail',
    params: {
      ...base,
      targetW: 384,
      targetH: 384,
      pixelSize: 3,
      thickness: 5,
      mode: 'k_centroid',
      sharpenMode: 'unsharp',
      doColorMatch: true,
      doQuant: false,
      ditherMode: 'none',
    },
  },
  {
    // Lo-fi: chunky pixels, cheap base resample, tiny palette, error diffusion
    id: 'lofi',
    labelKey: 'preset.lofi',
    params: {
      ...base,
      targetW: 128,
      targetH: 128,
      pixelSize: 6,
      thickness: 2,
      mode: 'bicubic',
      doColorMatch: true,
      doQuant: true,
      numColors: 16,
      quantMode: 'weighted-kmeans',
      ditherMode: 'error_diffusion',
    },
  },
];
